import { cn } from "@/lib/utils";
import logoLight from "@/assets/claira-logo.png";
import logoDark from "@/assets/claira-logo-dark.png";

/**
 * Full-viewport branded loading screen. Uses the main (vertical) logo with
 * automatic light/dark variants.
 */
export function LoadingScreen({
  className,
  label = "Loading…",
}: {
  className?: string;
  label?: string;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn(
        "fixed inset-0 z-[100] flex flex-col items-center justify-center",
        "bg-background text-foreground",
        className,
      )}
    >
      <img
        src={logoLight}
        alt="Claira — Mental Health Screening"
        className="light-only h-40 md:h-56 w-auto object-contain animate-pulse"
        draggable={false}
      />
      <img
        src={logoDark}
        alt="Claira — Mental Health Screening"
        className="dark-only h-40 md:h-56 w-auto object-contain animate-pulse"
        draggable={false}
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}

export default LoadingScreen;
